<template>
  <div>
    <Subheader v-model="search" title="Guidelines" search="guidelines"></Subheader>
    <v-card>
      <v-card-text>
        <v-alert :value="true" class="ma-0" color="warning lighten-2" icon="warning" outline>
          <span class="primary--text py-2">
            Highlighted guidelines have one or more standards without any analyte links assigned.
          </span>
        </v-alert>
        <v-data-table :headers="headers" :items="GuidelineList" :pagination.sync="pagination" :search="search">
          <template slot="items" slot-scope="props">
            <tr :class="[getColor(props.item)]">
              <td class="text-xs-left">{{ props.item.GuidelineLongName }} ({{props.item.GuidelineName}})</td>
              <td class="text-xs-left">{{ props.item.Category }}</td>
              <td class="text-xs-left">{{ props.item.MediasString }}</td>
              <td class="text-xs-left">{{ props.item.LastModifiedDateTime != null ? formatDate(props.item.LastModifiedDateTime, prettyDateTimeFormat) : '' }}</td>
              <td class="text-xs-right">
                <v-btn small :to="{ name: 'tenantGuidelinesDetail', params: { name: props.item.GuidelineName, } }">
                  <v-icon class="mr-2" color="warning">edit</v-icon>
                  {{ $t('Button.Edit') }}
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import PageHeader from '@/components/generic/PageHeader'
  import Subheader from '@/components/generic/Subheader'
  import AnalyteUtil from '../mixins/AnalyteUtil'
  const stations = createNamespacedHelpers('stations')
  const guidelines = createNamespacedHelpers('guidelines')
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  const analyte = createNamespacedHelpers('analyte')

  import { prettyDateTimeFormat, formatDate } from '@/components/mixins/MomentUtil'

  export default {
    components: {
      PageHeader,
      Subheader,
    },
    mixins: [AnalyteUtil],
    props: {},
    data() {
      return {
        prettyDateTimeFormat,
        tab: 'tab-1',
        search: '',
        guidelineCheckList: [],
        headers: [{
          text: 'Name',
          value: 'GuidelineLongName',
          align: 'left',
        },
        {
          text: 'Category',
          value: 'Category',
          align: 'left',
        },
        {
          text: 'Feasible Media Types',
          value: 'Medias',
          align: 'left',
        },
        {
          text: 'Last Modify Date',
          value: 'LastModifiedDateTime',
          align: 'left',
        },
        {
          value: null,
        },
        ],
        pagination: {
          sortBy: 'longName',
          rowsPerPage: 10,
        },
      }
    },
    mounted() {
      if (!this.roleList || !this.roleList.length) {
        this.getRoleList()
      }
      if (this.currentUserGroup.id) {
        this.GuidelineCheck()
      }
    },
    computed: {
      ...stations.mapGetters(['mediaTypeList']),
      ...guidelines.mapGetters(['Guidelines']),
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['currentUserGroup']),
      ...analyte.mapGetters(['tenantAnalyteList']),
      tenantList() {
        return JSON.parse(JSON.stringify(this.roleList))
      },
      GuidelineList() {
        let data = JSON.parse(JSON.stringify(this.Guidelines))
        let matched = data.filter(x => x.TenantGuidelines.some(t => t.TenantId == this.currentUserGroup.id))
        matched.forEach(element => {
          element.MediasString = element.Medias.map(x => x.Name).join()
          element.LastModifiedDateTime = element.Standards.map(x => x.LastModifiedDateTime).sort((a, b) => (a < b ? 1 : -1))[0]
        })
        return matched
      },
      guidelinesIndex() {
        let index = {}
        this.guidelineCheckList.forEach(g => index[g.GuidelineId] = g)
        return index
      },
    },
    watch: {
      currentUserGroup() {
        this.GuidelineCheck()
      },
    },
    methods: {
      ...admin.mapActions(['getRoleList']),
      ...guidelines.mapActions(['CheckGuideline']),
      formatDate,
      GuidelineCheck() {
        let options = {
          data: this.currentUserGroup.id,
          successCb: (data) => {
            this.guidelineCheckList = data
          },
          failedCb: (error) => {
            console.error(error)
          },
        }
        this.CheckGuideline(options)
      },
      getColor(guideline) {
        let matched = this.guidelinesIndex[guideline.Id]
        return matched ? 'warning lighten-2' : ''
      },
    },
  }
</script>